import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=ad81389c&scoped=true&"
import script from "./Forgot.vue?vue&type=script&lang=js&"
export * from "./Forgot.vue?vue&type=script&lang=js&"
import style0 from "./Forgot.vue?vue&type=style&index=0&id=ad81389c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad81389c",
  null
  
)

export default component.exports